<template>
    <span class="object-telegram-links">
        <template v-for="(link, index) in links">
            <span v-if="index" :key="`${link.href}-separator`" aria-hidden="true">·</span>
            <a :key="link.href" :href="link.href" target="_blank" rel="noopener noreferrer" @click.stop>{{ link.title }}</a>
        </template>
        <span v-if="!links.length">—</span>
    </span>
</template>
<script>
import {objectTelegramLinks} from '@/utils/objectTelegramGroups';
export default {
    props: {object: {type: Object, required: true}},
    computed: {links() { return objectTelegramLinks(this.object); }}
};
</script>
<style scoped>
.object-telegram-links { display: inline-flex; flex-wrap: wrap; gap: 2px 6px; align-items: baseline; }
.object-telegram-links a { overflow-wrap: anywhere; }
</style>
